export default "__VITE_ASSET__CmkpeQ8R__"